<div [innerHTML]="htmlContent"></div>